export default __webpack_public_path__ + "static/media/logo.92a7ef18.png";